/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({

})

class FlexMultiSelect extends Component {
    state = {
        value : [],
        error : false,
        helper_text : ""
    }

    componentWillMount () {
        this.setState({...this.state, value : this.props.instance.value.list !== null ? this.getObjectifiedValues(this.props.instance.value.list) : []}, () => {
            console.log("Multi Select State : ", this.state)
            this.setErrorAndHelperText()
        })
    }

    getObjectifiedValues = (values) => {
        let obj_values = []

        if (values !== null) {
            let obj_values = values.map(value => {
                if (typeof value === 'string') {
                    let obj_value = {
                        value : value,
                        annotation : value
                    }
    
                    return obj_value
                } else if (typeof value === 'object') {
                    return value
                }
            })
            console.log("Objectified Values : ", obj_values)
            return obj_values
        } else {
            return []
        }
    }

    getValueType = (component) => {
        switch (component) {
            // case "multi_select" :
            //     return "list"

            default:
                return "list"
        }
    }

    getHelperText = () => {
        let helper_text
        if (this.state.error === false) {
            helper_text = this.getParam("helper_text", "text")
        } else {
            helper_text = "Invalid entry"
        }

        this.setState({...this.state, helper_text : helper_text})
    }

    getParam = (param_name, value_type) => {
        let parameter = null

        this.props.instance.component_params.map(param => {
            if (param.name === param_name) {
                parameter = param.value[value_type]
            }
        })

        return parameter
    }

    setErrorAndHelperText = () => {
        let config_error = this.getParam("error", "boolean")
        let helper_text = this.getParam("helper_text", "text")
        let error_message = this.getParam("error_message", "text") !== null ? this.getParam("error_message", "text") : this.getParam("helper_text", "text")

        if (config_error !== null) {
            this.setState({...this.state, 
                error : config_error, 
                helper_text : config_error === true ? error_message : helper_text
            })
        } else {
            this.setState({
                ...this.state,
                helper_text : helper_text
            })
        }
    }

    getErrorAndHelperText = () => {
        let state_error = this.state.error

        if (state_error === true) {
            this.setState({...this.state, error : true}, () => this.getHelperText())
        }
    }

    getOptions = () => {
        let options = this.getParam("options", "list")
        console.log('Options: ', options)

        if (options !== null) {
            let objectified_options = options.map(option => {
                if (typeof option === 'string') {
                    let object = {
                        value : option,
                        annotation : option
                    }
    
                    return object
                } else if (typeof option === 'object') {
                    return option
                }
            })
            console.log("Objectified Options : ", objectified_options)
            return objectified_options
        } else {
            return []
        }
    }

    validateAndPush = () => {
        if (this.state.value.length !== 0) {
            this.setState({...this.state, error : false} , () => {
                this.getHelperText()
                let values = this.state.value.map(val => {
                    return val.value
                })
                this.props.update_value(this.props.instance.id, this.getValueType(this.props.instance.component), values)
            })
        } else {
            this.setState({...this.state, error : true}, () => {
                this.getHelperText()
            })
        }
    }

    handleChange = (value) => {
        this.setState({...this.state, value: value}, () => {
            this.validateAndPush()
            console.log("State Value: ", this.state)
        })
    }

    getValues = () => {
        let values = this.state.value.map(value => {
            if (typeof value === 'string') {
                let object = {
                    value : value,
                    annotation : value
                }

                return object
            } else if (typeof option === 'object') {
                return value
            }
        })

        return values
    }

    render() {
        const { classes } = this.props
        return (
            <Autocomplete
                multiple
                style = {{width : '100%'}}
                value = {this.state.value}
                onChange = {(event, newValue) => this.handleChange(newValue)}
                onBlur = {this.validateAndPush}
                options={this.getOptions()}
                getOptionLabel={(option) => option.annotation ? option.annotation !== "" && option.annotation !== null ? option.annotation : option.value : option.value}
                // getOptionLabel={(option) => {
                //     console.log("Checking Option : ", option)
                //     return option.annotation
                // }}
                getOptionSelected={(option, value) =>  {
                    if(typeof option === 'object') {
                        return option.value === value.value  
                    } else {
                        return option === value
                    } 
                }}
                filterSelectedOptions
                ChipProps = {{
                    size : 'small'
                }}
                disabled = {this.props.disabled}
                renderInput={(params) => (
                <TextField
                    {...params}
                    variant="standard"
                    margin = 'dense'
                    label= {this.props.instance.name}
                    placeholder={this.getParam("place_holder", "text")}
                    helperText = {this.state.helper_text}
                    error = {this.state.error}
                />
                )}
            />
        );
    }
}

export default withStyles(styles)(FlexMultiSelect);